import { Grid, Paper } from "@mui/material"
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    }
});


const GridPaper = (props) => {

    const classes = useStyles();
    return (
        <Grid {...props} component={Paper} className={classes.paper}>
            {props.children}
        </Grid>
    )
}

export default GridPaper;